import { useQuery } from '@tanstack/react-query';

import { useRequest, queryClient, type QueryFunction } from '@frontend/api';

export type ComponentOpenActionsCount = {
  id: number;
  openActionsCount: number;
  resolvedActionsCount: number;
};

export type QuoteItemOpenActionsCount = {
  quoteItemId: number;
  components: ComponentOpenActionsCount[];
};

export type UseGetQuoteOpenActionsCountParams = {
  quoteId: number;
};

export const getQuoteOpenActionsCountQueryKey = (
  params: UseGetQuoteOpenActionsCountParams,
) => ['quote', 'open-actions-count', params.quoteId];

export const useGetQuoteOpenActionsCount: QueryFunction<
  QuoteItemOpenActionsCount[],
  [UseGetQuoteOpenActionsCountParams],
  ReturnType<typeof getQuoteOpenActionsCountQueryKey>
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getQuoteOpenActionsCountQueryKey(params);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request<QuoteItemOpenActionsCount[]>(
        `/rules/quote_open_actions_count/${params.quoteId}`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      ),
  });
};

export const invalidateQuoteOpenActionsCountQuery = ({
  quoteId,
}: UseGetQuoteOpenActionsCountParams) => {
  queryClient.invalidateQueries({
    queryKey: getQuoteOpenActionsCountQueryKey({ quoteId }),
  });
};
